<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProductTab',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isActive: true
    }
  }
}
</script>
